// extracted by mini-css-extract-plugin
module.exports = {"textWithImageBlock":"textWithImageBlock_textWithImageBlock__6X4WK"};